import(/* webpackMode: "eager", webpackExports: ["RoomsPageClient"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/HeroBanner/RoomsPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoomsPageContent"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Rooms/RoomsPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Testimonial.tsx");
